// cannot use private class fields until Firefox 90
const ARRAY = Symbol('array');
const UPDATE = Symbol('update');

export default class ArrayCacheSet extends Set {
  constructor(values = []) {
    super(values);
    this[UPDATE]();
  }

  [UPDATE]() {
    this[ARRAY] = Array.from(this.values());
  }

  add(value) {
    super.add(value);
    this[UPDATE]();
    return this;
  }

  delete(value) {
    super.delete(value);
    this[UPDATE]();
    return this;
  }
  
  toArray() {
    return this[ARRAY];
  }
}